<template>
  <li>
    <a
      v-if="item.is_external"
      ref="link"
      :href="item.path"
      target="_blank"
      :id="item.id"
      class="group flex items-center gap-x-3 rounded-md p-2 text-sm leading-6 cursor-pointer text-white/60 hover:text-white hover:bg-white/10">
      <div class="text-white/60 group-hover:text-white shrink-0 text-xl">
        <i :class="['fa-sharp fa-regular fa-fw', item.icon]" aria-hidden="true"></i>
      </div>
      <span class="flex-1">{{ item.name }}</span>
      <i v-if="item.path" class="fa-sharp fa-regular fa-fw fa-external-link" aria-hidden="true"></i>
    </a>
    <RouterLink
      v-else
      ref="link"
      :to="`/${path}`"
      :class="[
        isActive
          ? 'bg-accent-500 text-white hover:text-white hover:bg-accent-500'
          : 'text-white/60 hover:text-white hover:bg-white/10',
        'group flex items-center gap-x-3 rounded-md p-2 text-sm leading-6'
      ]">
      <div :class="[isActive ? 'text-white' : 'text-white/60 group-hover:text-white', 'shrink-0 text-xl']">
        <i :class="['fa-sharp fa-regular fa-fw', item.icon]" aria-hidden="true"></i>
      </div>
      <span class="flex-1 truncate">{{ item.name }}</span>
    </RouterLink>
  </li>
</template>

<script>
import { useSystemStore } from '@/stores/system'
import { mapState } from 'pinia'
import { RouterLink } from 'vue-router'
import * as Sentry from '@sentry/vue'

export default {
  components: { RouterLink },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState(useSystemStore, ['routes']),
    isActive() {
      return this.$route.path === `/${this.item.path}` || this.$route.path.indexOf(`/${this.item.path}/`) === 0
    },
    path() {
      return this.getPath(this.item, []).join('/')
    }
  },
  created() {
    this.$nextTick(() => {
      if (this.item?.id === 'sentryFeedback') {
        const feedback = Sentry.getFeedback()
        feedback?.attachTo(this.$refs.link)
      }
    })
  },
  methods: {
    getPath(item, path) {
      path.push(item.path)

      if (!item.show_tabs) {
        return path
      }

      const nextItem = this.routes.find((r) => r.parent_id === item.id)
      return this.getPath(nextItem, path)
    }
  }
}
</script>
